import {
    ModuleRegistry,
    CellStyleModule,
    ClientSideRowModelModule,
    PaginationModule,
    InfiniteRowModelModule,
    RowSelectionModule,
    RowApiModule,
    ScrollApiModule,
    LocaleModule,
    provideGlobalGridOptions,
    RowSelectionOptions,
} from 'ag-grid-community';

ModuleRegistry.registerModules([
    CellStyleModule,
    ClientSideRowModelModule,
    PaginationModule,
    InfiniteRowModelModule,
    RowSelectionModule,
    RowApiModule,
    ScrollApiModule,
    LocaleModule,
]);

provideGlobalGridOptions({
    animateRows: true,
    suppressCellFocus: true,
    domLayout: 'normal',
    localeText: {
        noRowsToShow: 'Nincs megjeleníthető adat',
    },
});

export const defaultRowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    checkboxes: false,
    enableClickSelection: true,
};
